import { RadioButton } from "primereact/radiobutton";
import React from "react";

type RegisterStep0Props = {
  formik: any;
};

const RegisterStep0: React.FC<RegisterStep0Props> = ({ formik }) => {
  return (
    <div className="flex flex-col gap-4 h-12rem">
      <div className="w-full p-3 rounded-lg border-2 border-dashed surface-border border-round surface-ground flex items-center font-medium">
        <RadioButton
          inputId="business"
          name="isEntreprise"
          variant="filled"
          value={true}
          onChange={(e) => formik.setFieldValue("isEntreprise", e.value)}
          checked={formik.values.isEntreprise === true}
        />
        <label htmlFor="business" className="ml-2 flex flex-col w-full">
          <span className="font-bold">Business</span>
          <span>Sign up as a company or an enterprise.</span>
        </label>
      </div>
      <div className="w-full p-3 rounded-lg border-2 border-dashed surface-border border-round surface-ground flex items-center font-medium">
        <RadioButton
          inputId="individual"
          variant="filled"
          name="isEntreprise"
          value={false}
          onChange={(e) => formik.setFieldValue("isEntreprise", e.value)}
          checked={formik.values.isEntreprise === false}
        />
        <label htmlFor="individual" className="ml-2 flex flex-col w-full">
          <span className="font-bold">Individual</span>
          <span>Sign up for personal use.</span>
        </label>
      </div>
    </div>
  );
};

export default RegisterStep0;
